<loader [isRootLoader]="true" [isVisible]="loadingState"></loader>
